module.exports = __webpack_public_path__ + "static/img/xian.24e256c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/xian.png
// module id = N9fK
// module chunks = 0